


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { FormFieldData, FormFieldType } from './formfield.models';

@Component({})
export default class FormField extends Vue {
  @Prop() private field!: FormFieldData;
  @Prop() private fieldName!: string;
  @Prop() private placeholder!: string;

  private FormFieldType: typeof FormFieldType = FormFieldType;

  @Emit('input')
  private handleInput(e: InputEvent) {
    return (e.srcElement as HTMLInputElement).value;
  }

  @Emit('focus')
  private handleFocus() {
    return;
  }

  private get formattedPlaceholder() {
    return this.field.required ? `${this.placeholder}*` : this.placeholder;
  }
}
